import classnames from 'classnames';
import React from 'react';

const CSS = require('./LoadingDots.less');

interface LoadingDotsProps {
  isWhite?: boolean;
  className?: string;
  size?: 's' | 'm';
}

function LoadingDots({ isWhite, className, size = 'm' }: LoadingDotsProps) {
  return (
    <div
      className={classnames(CSS.LoadingDots, {
        [CSS.LoadingDotsWhite]: isWhite,
        [className]: className,
        [CSS.Small]: size === 's',
      })}
    >
      <span className={CSS.LoadingDot}>·</span>
      <span className={`${CSS.LoadingDot} ${CSS.LoadingDot2}`}>·</span>
      <span className={`${CSS.LoadingDot} ${CSS.LoadingDot3}`}>·</span>
    </div>
  );
}

export default LoadingDots;
